import React from 'react';
import { IconProps } from './types';

export const SuccessIcon: React.FC<IconProps> = props => {
  const { className, size = 16, fillColor = '#00BA34', onClick } = props;
  return (
    <svg
      onClick={onClick}
      className={className}
      width={size}
      height={size}
      viewBox={`"0 0 ${size} ${size}"`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99967 1.33203C4.31967 1.33203 1.33301 4.3187 1.33301 7.9987C1.33301 11.6787 4.31967 14.6654 7.99967 14.6654C11.6797 14.6654 14.6663 11.6787 14.6663 7.9987C14.6663 4.3187 11.6797 1.33203 7.99967 1.33203ZM7.99967 13.332C5.05967 13.332 2.66634 10.9387 2.66634 7.9987C2.66634 5.0587 5.05967 2.66536 7.99967 2.66536C10.9397 2.66536 13.333 5.0587 13.333 7.9987C13.333 10.9387 10.9397 13.332 7.99967 13.332ZM10.5863 5.52536L6.66634 9.44536L5.41301 8.19203C5.15301 7.93203 4.73301 7.93203 4.47301 8.19203C4.21301 8.45203 4.21301 8.87203 4.47301 9.13203L6.19967 10.8587C6.45967 11.1187 6.87967 11.1187 7.13967 10.8587L11.533 6.46536C11.793 6.20536 11.793 5.78536 11.533 5.52536C11.273 5.26536 10.8463 5.26536 10.5863 5.52536Z"
        fill={fillColor}
      />
    </svg>
  );
};
